/**
 * Shared type definitions and constants for the tour system.
 */
import type { DriveStep } from "driver.js";

export type TourStep = DriveStep;

export type FeaturePageTour = {
  path: string;
  waitFor: string;
  /**
   * Steps, or a function resolved once the page is ready so the copy can
   * adapt to what's actually on screen (e.g. a plan-locked feature).
   */
  steps: TourStep[] | (() => TourStep[]);
};

/**
 * Bump this on a release that should re-offer the tour to everyone. Both the
 * "seen" and "completed" markers are stored as this value, so a marker from an
 * older version no longer suppresses the greeting or counts as completed.
 */
export const TOUR_VERSION = "2";

export const TOUR_COMPLETED_KEY = "resumex_tour_completed";
export const TOUR_SEEN_VERSION_KEY = "resumex_tour_seen_version";
export const NEWSLETTER_PROMPTED_KEY = "resumex_newsletter_prompted";
export const FEEDBACK_SUBMITTED_EVENT = "feedback:submitted";
export const CV_SAVED_EVENT = "cv:saved";
export const CV_DOWNLOAD_CONFIRMED_EVENT = "cv:download-confirmed";

export const getUserKey = (baseKey: string, userId?: string) =>
  userId ? `${baseKey}_${userId}` : baseKey;
